/* CPAP machine PDP — inline bundle builder. Mask 50%-off applies at checkout (Bxgy discount). */
(function () {
  'use strict';
  var root = document.querySelector('[data-bundle]');
  if (!root) return;
  var isAirmini = root.hasAttribute('data-airmini');

  function money(cents) {
    var d = cents / 100;
    var dec = d % 1 === 0 ? 0 : 2;
    return '$' + d.toLocaleString('en-AU', { minimumFractionDigits: dec, maximumFractionDigits: dec });
  }

  var machine = {
    variant: root.getAttribute('data-machine-variant'),
    price: parseInt(root.getAttribute('data-machine-price'), 10) || 0,
    rrp: parseInt(root.getAttribute('data-machine-rrp'), 10) || 0,
    name: root.getAttribute('data-machine-name'),
    product: root.getAttribute('data-machine-product') || ''
  };
  var mask = null;             // { variant, price(full cents), name }
  var addons = {};             // variant -> { price, name }
  var needsAirminiAdapter = false;  // true when the active mask was picked from the standard-mask tab (requires the tubing adaptor)
  var airminiAdapter = (function () {
    var v = root.getAttribute('data-airmini-adapter-variant');
    if (!v) return null;
    return {
      variant: v,
      price: parseInt(root.getAttribute('data-airmini-adapter-price'), 10) || 0,
      name: root.getAttribute('data-airmini-adapter-name') || 'Universal Tubing Adaptor Kit for ResMed AirMini'
    };
  })();

  /* ---- AirMini tab switcher (direct-fit vs use-any-mask + tubing adaptor) ---- */
  root.querySelectorAll('[data-airmini-tab]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = btn.getAttribute('data-airmini-tab');
      root.querySelectorAll('[data-airmini-tab]').forEach(function (b) { b.classList.toggle('on', b === btn); });
      root.querySelectorAll('[data-airmini-pane]').forEach(function (pane) {
        pane.hidden = pane.getAttribute('data-airmini-pane') !== target;
      });
      root.querySelectorAll('[data-airmini-note]').forEach(function (n) {
        n.hidden = n.getAttribute('data-airmini-note') !== target;
      });
    });
  });

  /* ---- Gift-with-purchase (locked, pre-included; data-driven from snippet) ----
     Cart-add strategy:
     - If data-gift-cart-variant is set (a hidden Bundles SKU like as11-eofy-gift-pack),
       add ONE bundle line — a matching BXGY (Buy machine -> 100% off bundle) zeroes it.
     - Otherwise, fall back to adding each variant in data-gift-variants. */
  var giftSlot = root.querySelector('[data-slot="gift"]');
  var giftVariants = giftSlot && giftSlot.getAttribute('data-gift-variants')
    ? giftSlot.getAttribute('data-gift-variants').split(',').filter(Boolean)
    : [];
  var giftCartVariant = giftSlot ? (giftSlot.getAttribute('data-gift-cart-variant') || '') : '';
  var giftCartVariants = giftCartVariant ? [giftCartVariant] : giftVariants;
  var giftRrpTotal = giftSlot ? (parseInt(giftSlot.getAttribute('data-gift-rrp'), 10) || 0) : 0;
  var giftLabel = giftSlot ? (giftSlot.getAttribute('data-gift-label') || '') : '';

  /* Choose-one gift (data-gift-choose): the customer picks ONE gift card; only
     that variant is added. The gwp discount Function zeroes it server-side when
     the machine is in the cart (custom.gwp_eligible_machine on the gift product). */
  if (giftSlot && giftSlot.hasAttribute('data-gift-choose')) {
    /* The PDP's other buttons (Add to cart, Buy now, sticky bar) add only the
       machine. They call this to append the chosen gift, so every path gets it. */
    /* Included gifts (gift_choice.included_gifts): always added with the chosen one.
       Each gift line carries _gwp_group (product custom.gwp_group) so the cart
       cleanup keeps one gift per machine PER GROUP (Philips Q4 2026: toothbrush
       + shaver-or-epilator). */
    var included = Array.prototype.map.call(giftSlot.querySelectorAll('[data-gift-included-variant]'), function (c) {
      return { id: c.getAttribute('data-gift-included-variant'), price: parseInt(c.getAttribute('data-gift-price'), 10) || 0,
               name: c.getAttribute('data-gift-name') || 'gift', group: c.getAttribute('data-gift-group') || '' };
    });
    var picked = giftSlot.querySelector('[data-gift-variant].is-picked');
    var chosen = picked ? { id: picked.getAttribute('data-gift-variant'), price: parseInt(picked.getAttribute('data-gift-price'), 10) || 0,
                            name: picked.getAttribute('data-gift-name') || 'gift', group: picked.getAttribute('data-gift-group') || '' } : null;
    function recalcGift() {
      var all = included.concat(chosen ? [chosen] : []);
      giftCartVariants = all.map(function (g) { return g.id; });
      giftRrpTotal = all.reduce(function (n, g) { return n + g.price; }, 0);
      giftLabel = all.length ? 'Free ' + all.map(function (g) { return g.name; }).join(' + ') : '';
    }
    recalcGift();
    window.cdwGwpGiftItems = function (handled) {
      return included.concat(chosen ? [chosen] : []).map(function (g) {
        return { id: Number(g.id), quantity: 1, properties: { '_gwp_source': String(machine.variant), '_gwp_machine': machine.product,
          '_gwp_group': g.group, '_gwp_rule': 'Free ' + g.name, '_gwp_handled': handled || 'pdp-button' } };
      });
    };
    /* Old single-item API (kept for any cached caller): the first gift only. */
    window.cdwGwpChoiceItem = function () { var a = window.cdwGwpGiftItems(); return a.length ? a[0] : null; };
    /* Note under the main Add to cart button: shows the chosen gift + a link to change it. */
    var giftNote = null;
    var mainAdd = document.querySelector('.cpap-pdp [data-add-to-cart]:not(.pdp-sticky [data-add-to-cart])');
    if (mainAdd && giftCartVariants.length) {
      giftNote = document.createElement('p');
      giftNote.className = 'gwp-choice-note';
      giftNote.setAttribute('style', 'margin:8px 0 0;font-size:13px;line-height:1.45;color:var(--ink,#043146);');
      var anchor = document.querySelector('.cpap-pdp [data-buy-now]') || mainAdd.closest('div') || mainAdd;
      anchor.parentNode.insertBefore(giftNote, anchor.nextSibling);
    }
    function setGiftNote() {
      if (!giftNote) return;
      giftNote.innerHTML = '';
      giftNote.appendChild(document.createTextNode('🎁 ' + giftLabel + ' (worth ' + money(giftRrpTotal) + ') ' + (giftCartVariants.length > 1 ? 'are' : 'is') + ' included. '));
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = 'Change gift';
      b.setAttribute('style', 'background:none;border:0;padding:0;font:inherit;color:inherit;font-weight:600;text-decoration:underline;cursor:pointer;');
      b.addEventListener('click', function () {
        var top = giftSlot.getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
      giftNote.appendChild(b);
    }
    setGiftNote();

    giftSlot.querySelectorAll('[data-gift-variant]').forEach(function (card) {
      card.addEventListener('click', function () {
        if (card.disabled) return;
        chosen = { id: card.getAttribute('data-gift-variant'), price: parseInt(card.getAttribute('data-gift-price'), 10) || 0,
                   name: card.getAttribute('data-gift-name') || 'gift', group: card.getAttribute('data-gift-group') || '' };
        recalcGift();
        giftSlot.querySelectorAll('[data-gift-variant]').forEach(function (c) {
          var on = c === card;
          c.classList.toggle('is-picked', on);
          c.setAttribute('aria-pressed', on ? 'true' : 'false');
          var l = c.querySelector('[data-gift-pick-label]');
          if (l) l.textContent = on ? 'Your choice' : 'Choose this gift';
        });
        var pill = giftSlot.querySelector('[data-gift-value]');
        if (pill) pill.textContent = 'worth ' + money(giftRrpTotal);
        setGiftNote();
        update();
      });
    });
  }

  /* ---- slot accordion ---- */
  root.querySelectorAll('[data-slot-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () { btn.closest('.bi-slot').classList.toggle('is-open'); });
  });

  /* ---- mask filters (type + brand, combined with AND) ---- */
  var activeType = 'all', activeBrand = 'all';
  function applyFilters() {
    root.querySelectorAll('[data-mask-card]').forEach(function (card) {
      var cat = card.getAttribute('data-cat') || '';
      var brand = card.getAttribute('data-brand') || '';
      var typeOk = activeType === 'all' || cat === activeType;
      var brandOk = activeBrand === 'all' || brand === activeBrand;
      card.style.display = (typeOk && brandOk) ? '' : 'none';
    });
  }
  root.querySelectorAll('.bi-filters[data-group="type"] .bi-filter').forEach(function (f) {
    f.addEventListener('click', function () {
      root.querySelectorAll('.bi-filters[data-group="type"] .bi-filter').forEach(function (x) { x.classList.toggle('on', x === f); });
      activeType = f.getAttribute('data-filter');
      applyFilters();
    });
  });
  root.querySelectorAll('.bi-filters[data-group="brand"] .bi-filter').forEach(function (f) {
    f.addEventListener('click', function () {
      root.querySelectorAll('.bi-filters[data-group="brand"] .bi-filter').forEach(function (x) { x.classList.toggle('on', x === f); });
      activeBrand = f.getAttribute('data-brand');
      applyFilters();
    });
  });

  /* ---- clear the 'choose a size' prompt once a size is picked ---- */
  root.querySelectorAll('select.bi-size').forEach(function (s) {
    s.addEventListener('change', function () {
      s.classList.remove('err');
      var msg = s.parentNode.querySelector('[data-size-msg]');
      if (msg) msg.hidden = true;
    });
  });

  /* ---- add mask ---- */
  root.querySelectorAll('[data-add-mask]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('[data-mask-card]');
      var sel = card.querySelector('[data-mask-variants]');
      var variant, price;
      if (sel && sel.tagName === 'SELECT') {
        if (!sel.value) {
          // CRO: nothing is pre-selected — prompt for a size instead of guessing
          var msg = card.querySelector('[data-size-msg]');
          if (msg) msg.hidden = false;
          sel.classList.add('err');
          sel.focus();
          return;
        }
        var opt = sel.options[sel.selectedIndex];
        variant = opt.value; price = parseInt(opt.getAttribute('data-price'), 10) || parseInt(btn.getAttribute('data-price'), 10);
      } else {
        variant = btn.getAttribute('data-single-variant'); price = parseInt(btn.getAttribute('data-price'), 10);
      }
      mask = { variant: variant, price: price, name: btn.getAttribute('data-name') };
      // AirMini: mark whether this mask was picked from the adapter tab — bundle add will append the tubing adaptor.
      needsAirminiAdapter = btn.getAttribute('data-needs-adapter') === 'true' && !!airminiAdapter;
      // visual state
      root.querySelectorAll('[data-mask-card]').forEach(function (c) { c.classList.toggle('is-picked', c === card); });
      root.querySelectorAll('[data-add-mask]').forEach(function (b) { b.textContent = '+ Add'; b.classList.remove('added'); });
      btn.textContent = '✓ Added'; btn.classList.add('added');
      // mark slot complete + advance to add-ons
      var maskSlot = root.querySelector('[data-slot="mask"]');
      maskSlot.classList.add('is-complete'); maskSlot.querySelector('.bi-num').classList.add('is-done');
      maskSlot.querySelector('.bi-num').innerHTML = '✓';
      var addonsSlot = root.querySelector('[data-slot="addons"]');
      if (addonsSlot) { maskSlot.classList.remove('is-open'); addonsSlot.classList.add('is-open'); }
      update();
    });
  });

  /* ---- add-ons (toggle) ---- */
  root.querySelectorAll('[data-add-addon]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var v = btn.getAttribute('data-variant');
      if (addons[v]) { delete addons[v]; btn.textContent = '+ Add'; btn.classList.remove('added'); btn.closest('[data-addon-card]').classList.remove('is-picked'); }
      else { addons[v] = { price: parseInt(btn.getAttribute('data-price'), 10), name: btn.getAttribute('data-name') }; btn.textContent = '✓ Added'; btn.classList.add('added'); btn.closest('[data-addon-card]').classList.add('is-picked'); }
      update();
    });
  });

  /* ---- recompute footer ---- */
  function update() {
    var names = [machine.name];
    var nowTotal = machine.price;
    var wasTotal = machine.rrp;
    var saving = 0;
    if (mask) {
      if (isAirmini) {
        nowTotal += mask.price; wasTotal += mask.price;
      } else {
        var half = Math.round(mask.price / 2);
        nowTotal += half; wasTotal += mask.price; saving += (mask.price - half);
      }
      names.push(mask.name);
    }
    Object.keys(addons).forEach(function (v) { nowTotal += addons[v].price; wasTotal += addons[v].price; names.push(addons[v].name); });

    /* Gift: add RRP to the "was" total + saving; "now" already counts $0 (gift not charged). */
    if (giftRrpTotal > 0) {
      wasTotal += giftRrpTotal;
      saving += giftRrpTotal;
      if (giftLabel) { names.push('🎁 ' + giftLabel); }
    }

    var count = 1 + (mask ? 1 : 0) + Object.keys(addons).length;
    var summaryEl = root.querySelector('[data-bi-summary]');
    if (mask) {
      summaryEl.textContent = giftRrpTotal > 0
        ? (count + (count === 1 ? ' item' : ' items') + ' + 🎁 free gift in your bundle')
        : (count + (count === 1 ? ' item' : ' items') + ' in your bundle');
    } else if (isAirmini) {
      summaryEl.textContent = 'Pick a setup pack to complete your AirMini.';
    } else {
      summaryEl.textContent = giftRrpTotal > 0
        ? 'Your free gift is included. Add a mask to save 50% off.'
        : 'Add a mask to save 50% with this bundle.';
    }
    root.querySelector('[data-bi-names]').textContent = mask ? names.join(' · ') : (giftRrpTotal > 0 ? (machine.name + ' · 🎁 ' + (giftLabel || 'Free gift')) : machine.name);

    var nowEl = root.querySelector('[data-bi-now]'), wasEl = root.querySelector('[data-bi-was]'), saveEl = root.querySelector('[data-bi-saving]');
    nowEl.textContent = money(nowTotal);
    if (wasTotal > nowTotal) { wasEl.textContent = money(wasTotal); wasEl.hidden = false; } else { wasEl.hidden = true; }
    if (saving > 0) {
      var savingLabel = (giftRrpTotal > 0 && mask)
        ? ('Bundle saving · ' + money(saving) + ' (incl. ' + money(giftRrpTotal) + ' free gift)')
        : ('Bundle saving · ' + money(saving));
      saveEl.textContent = savingLabel; saveEl.hidden = false;
    } else {
      saveEl.hidden = true;
    }

    var filledEl = root.querySelector('[data-bi-filled]');
    if (filledEl) { filledEl.textContent = mask ? '1' : '0'; }
    root.querySelector('[data-bi-progress]').style.width = (mask ? 100 : (giftRrpTotal > 0 ? 50 : 0)) + '%';

    var cta = root.querySelector('[data-bi-addcart]');
    if (isAirmini) {
      cta.disabled = !mask;
      cta.textContent = mask ? 'Add bundle to cart' : 'Pick a setup pack to continue';
    } else {
      cta.disabled = false;
      cta.textContent = mask ? 'Add bundle to cart' : 'Add to cart';
    }
  }

  /* ---- add bundle to cart ---- */
  root.querySelector('[data-bi-addcart]').addEventListener('click', function () {
    if (isAirmini && !mask) return;
    var cta = this; cta.disabled = true; cta.textContent = 'Adding…';
    var items = [{ id: Number(machine.variant), quantity: 1 }];
    if (mask) { items.push({ id: Number(mask.variant), quantity: 1 }); }
    /* AirMini: auto-append the tubing adaptor when the mask was picked from the "use any mask" tab. */
    if (needsAirminiAdapter && airminiAdapter) {
      items.push({
        id: Number(airminiAdapter.variant),
        quantity: 1,
        properties: { '_airmini_adapter': 'auto', '_pairs_with': String(mask.variant) }
      });
    }
    Object.keys(addons).forEach(function (v) { items.push({ id: Number(v), quantity: 1 }); });
    /* Append the gift line(s) tagged with _gwp_* properties.
       - giftCartVariants = [bundle SKU] when GWP entry has cart_add_variant set,
         otherwise the full list of display gifts.
       - _gwp_handled='section' tells a Cart Transform Function (future) not to add duplicates.
       - A matching BXGY auto-discount (Buy machine -> 100% off the cart-add line) zeroes the price server-side. */
    if (typeof window.cdwGwpGiftItems === 'function' && giftSlot && giftSlot.hasAttribute('data-gift-choose')) {
      window.cdwGwpGiftItems('section').forEach(function (it) { items.push(it); });
    } else giftCartVariants.forEach(function (gv) {
      items.push({
        id: Number(gv),
        quantity: 1,
        properties: {
          '_gwp_source': String(machine.variant),
          '_gwp_machine': machine.product,
          '_gwp_rule': giftLabel,
          '_gwp_handled': 'section'
        }
      });
    });
    var sectionIds = Array.prototype.map
      .call(document.querySelectorAll('cart-items-component[data-section-id]'), function (el) {
        return el.getAttribute('data-section-id');
      })
      .filter(Boolean);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items, sections: sectionIds.join(','), sections_url: window.location.pathname })
    })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function (d) {
        // Pass rendered sections under detail.data so the drawer morphs straight
        // to the new cart (falls back to a fresh fetch if absent).
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'cpap-bundle', sections: d && d.sections } }
        }));
        cta.textContent = isAirmini ? 'Added ✓ — ships with your AirMini' : 'Added ✓ — 50% off applies at checkout';
        setTimeout(function () { cta.disabled = false; cta.textContent = 'Add bundle to cart'; }, 2600);
      })
      .catch(function () { window.location.href = '/cart'; });
  });

  /* ---- scroll from buy-column entry card ---- */
  document.querySelectorAll('[data-scroll-to-bundle]').forEach(function (b) {
    b.addEventListener('click', function () {
      var top = root.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
      root.querySelector('[data-slot="mask"]').classList.add('is-open');
    });
  });
})();